const CookieBanner = () => {
    const cookieBanner = document.getElementById('js-cookie-banner');
    const cookieAcceptBtn = document.getElementById('js-cookie-accept');

    if (!cookieBanner) {
        console.warn('Cookie banner not found');
        return;
    }

    const showBanner = () => {
        if (localStorage.getItem('cookiesAccepted') !== 'true') {
            cookieBanner.classList.add('show');
        }
    };

    const acceptCookies = () => {
        localStorage.setItem('cookiesAccepted', 'true');
        cookieBanner.classList.remove('show');
    };

    cookieAcceptBtn?.addEventListener('click', acceptCookies);

    showBanner();
};

export default CookieBanner;
